import { ElementVisibilityTypes } from './Enums/element-visibility-types';

export class ElementVisibility {
    public constructor(
        public type: ElementVisibilityTypes,
        public visible: boolean
    ) {}
}
